// The icon motifs in ALPHABETICAL ORDER
export enum IconMotif {
  Alternatives = 'alternatives',
  ArrowLeft = 'arrowLeft',
  ArrowsRotate = 'arrowsRotate',
  Bike = 'bike',
  Briefcase = 'briefcase',
  Bus = 'bus',
  Calendar = 'calendar',
  CalendarWithArrow = 'calendarWithArrow',
  Car = 'car',
  Check = 'Check',
  ChevronDown = 'chevronDown',
  ChevronUp = 'chevronUp',
  Clock = 'clock',
  Exclamation = 'exclamation',
  FaceLaugh = 'faceLaugh',
  FileLines = 'fileLines',
  Ferry = 'ferry',
  Gear = 'gear',
  House = 'house',
  Info = 'info',
  Leaf = 'leaf',
  Municipality = 'municipality',
  Pen = 'pen',
  PersonAtStop = 'personAtStop',
  Plus = 'plus',
  RotateLeft = 'rotateLeft',
  ShoeWalking = 'shoeWalking',
  StopArea = 'stopArea',
  Taxi = 'taxi',
  ThumbsDown = 'thumbsDown',
  ThumbsUp = 'thumbsUp',
  Trash = 'trash',
  Train = 'train',
  Tram = 'tram',
  Walk = 'walk',
}
